import { render } from "./ExternalVariantsView.vue?vue&type=template&id=3d870d8c&scoped=true&ts=true"
import script from "./ExternalVariantsView.vue?vue&type=script&lang=ts"
export * from "./ExternalVariantsView.vue?vue&type=script&lang=ts"

import "./ExternalVariantsView.vue?vue&type=style&index=0&id=3d870d8c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d870d8c"]])

export default __exports__